module.exports = "pegasus/assets/icn_6.png";